import type React from 'react';
import { ShareholderFormDrawer } from '@/pages/accounting/registers/dividends/components/shareholderFormDrawer/ShareholderFormDrawer';
import { todayIso } from '@/pages/accounting/statements/statementMeta';
import { PATH } from '@/router/PATH';
import type { ActionSurfaceProps } from '../../controlCenterSurfaces';

/**
 * "New shareholder" from the launcher — the Dividends register's **own**
 * drawer. `asOf` is today: the equity position the register would show if
 * opened right now, same as `useDividendsPage` seeds it.
 *
 * The message is generic — the drawer's own `onSaved` fires with no
 * arguments, so there is no created shareholder's name to interpolate.
 */
export const AddShareholderSurface: React.FC<ActionSurfaceProps> = ({
    onClose,
    onDone,
}) => (
    <ShareholderFormDrawer
        asOf={todayIso()}
        isOpen
        onClose={onClose}
        onSaved={() =>
            onDone({
                messageKey: 'controlCenter.outcome.shareholderAdded',
                to: PATH.ACCOUNTING.REGISTERS.DIVIDENDS,
                linkKey: 'controlCenter.outcome.openDividends',
            })
        }
        shareholder={null}
    />
);
